var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"back-button"},[_c('router-link',{attrs:{"to":"/"}},[_c('i',{staticClass:"angle left icon",on:{"click":function($event){return _vm.$store.commit('toggleSidebar')}}}),_vm._v(" Back home")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }